"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventItemAvailable = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var EventItemAvailable = function (_a) {
    var canSelect = _a.canSelect, label = _a.label, isSelected = _a.isSelected, onSelect = _a.onSelect;
    return (react_1.default.createElement("div", { className: storybook_1.Helpers.arrayToString(__spreadArray(__spreadArray([
            'storybook-producer-ea'
        ], (isSelected ? ['storybook-producer-ea-selected'] : [])), (!canSelect ? ['storybook-producer-ea-disabled'] : []))), onClick: function () { return canSelect ? onSelect() : function () { }; } }, label));
};
exports.EventItemAvailable = EventItemAvailable;
exports.EventItemAvailable.propTypes = {
    canSelect: prop_types_1.default.bool,
    label: prop_types_1.default.string,
    isSelected: prop_types_1.default.bool,
    onSelect: prop_types_1.default.func,
};
exports.EventItemAvailable.defaultProps = {
    canSelect: false,
    label: '',
    isSelected: false,
    onSelect: function () { }
};
